import styled from 'styled-components';

interface WrapperProps {
  fixed?:boolean
}

export const Wrapper = styled.div<WrapperProps>`
  @media (max-width: 1882px) {
    right: 14%;
  }

  @media (max-width: 1800px) {
    right: 13%;
  }
  
  @media (max-width: 1700px) {
    right: 12%;
  }
  
  @media (max-width: 1650px) {
    right: 11%;
  }

  @media (max-width: 1600px) {
    right: 10%;
  }
  
  @media (max-width: 1580px) {
    right: 5%;
  }

  @media (max-width: 1420px) {
    right: 3%;
  }


  @media (max-width: 1400px) {
    display: none;
  }
  
  z-index: 1;
  position: ${props => props.fixed ? 'fixed' : 'absolute'};
  right: 16%;
  top: 144px;
  width: 220px;

  background: #FFFFFF;

  box-shadow: 0px 2px 15px rgba(100, 114, 140, 0.25);
  border-radius: 10px;
  padding: 12px;

  button.newsletter {
    margin: 14px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FCFF7C;
    border-radius: 100px;
    border: 0;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 140.62%;
    text-align: center;
    color: #2253F5;
    width: 100%;
    padding: 6px 0;

    span {
      margin-bottom: -2px;
      margin-left: 10px;
    }
  }

  p {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 140.62%;
    color: #333333;
  }

  a {
    padding: 6px 2px;
    display:block;
    text-decoration: none;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140.62%;
    color: #64728C;

    &:hover {
      font-weight: 700;
      color: #2253F5;

    }

    &.post {
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      color: #64728C;
      padding: 16px 4px;

      &:not(:last-child) {
        border-bottom: 1px solid #E8EAEF;
      }
      
      &:first-child {
        padding-top: 0;
      }
      
      &:hover {
        color: #2253F5;
      }
    }
  }
`;
